webpackJsonp([70144966829960],{

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: "section" },
	    _react2.default.createElement(
	      "div",
	      { className: "columns is-centered" },
	      _react2.default.createElement(
	        "div",
	        { className: "column is-two-thirds is-half-desktop" },
	        _react2.default.createElement(
	          "p",
	          null,
	          "Thanks so much for stopping by. Fill in the form below for any inquiries regarding sales, commissions, or more information about any of the artwork."
	        ),
	        _react2.default.createElement(
	          "form",
	          { name: "contact", method: "POST", "data-netlify": "true", action: "/" },
	          _react2.default.createElement("input", { type: "hidden", name: "form-name", value: "contact" }),
	          _react2.default.createElement(
	            "div",
	            { className: "field" },
	            _react2.default.createElement(
	              "label",
	              { className: "label", htmlFor: "name" },
	              "Name"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "control" },
	              _react2.default.createElement("input", { className: "input", type: "text", name: "name", placeholder: "Your Name" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "field" },
	            _react2.default.createElement(
	              "label",
	              { className: "label", htmlFor: "email" },
	              "Email"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "control" },
	              _react2.default.createElement("input", { className: "input", type: "email", name: "email", placeholder: "Email input" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "field" },
	            _react2.default.createElement(
	              "label",
	              { className: "label", htmlFor: "subject" },
	              "Subject"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "control" },
	              _react2.default.createElement("input", { className: "input", type: "text", name: "subject", placeholder: "Text input" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "field" },
	            _react2.default.createElement(
	              "label",
	              { className: "label", htmlFor: "message" },
	              "Message"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "control" },
	              _react2.default.createElement("textarea", { className: "textarea", name: "message", placeholder: "Textarea" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "field is-grouped" },
	            _react2.default.createElement(
	              "div",
	              { className: "control" },
	              _react2.default.createElement(
	                "button",
	                { className: "button" },
	                "Submit"
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-d6ff1bfc41ba18f8c3f6.js